import React from 'react';
import { withRouter } from 'react-router-dom';
import { withFormik, Field } from 'formik';
import { Button, Form } from 'reactstrap';
import * as yup from 'yup';

import FieldInputComponent from 'components/FieldInputComponent';

import { MIN_PASSWORD_LENGTH } from 'helpers/constants';

const EditPasswordSchema = yup.object().shape({
  password: yup
    .string()
    .min(
      MIN_PASSWORD_LENGTH,
      `Password has to be longer than ${MIN_PASSWORD_LENGTH} characters!`,
    )
    .required("Password can't be empty"),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Password confirmation did not match!')
    .min(
      MIN_PASSWORD_LENGTH,
      `Password confirmation has to be longer than ${MIN_PASSWORD_LENGTH} characters!`,
    )
    .required("Password confirmation can't be empty"),
});

const EditPasswordForm = ({
  match,
  isSubmitting,
  handleSubmit,
  isValid,
  touched,
  errors,
}) => {
  return (
    <Form className="order-form">
      <div className="h2-title big center">New password</div>
      <div className="separator-line" />
      <Field
        name="password"
        component={FieldInputComponent}
        error={touched.password && errors.password}
        type="password"
        label="Password"
        classInput="form-input input-border"
      />
      <Field
        name="password_confirmation"
        component={FieldInputComponent}
        error={touched.password_confirmation && errors.password_confirmation}
        type="password"
        label="Password confirmation"
        classInput="form-input input-border"
      />
      <Field
        name="reset_password_token"
        render={({ field }) => <input type="hidden" {...field} />}
      />
      <Button
        color="blue"
        className="m-r-15"
        onClick={handleSubmit}
        disabled={!isValid || isSubmitting}>
        {isSubmitting ? 'Loading' : 'Change my password'}
      </Button>{' '}
    </Form>
  );
};
export default withRouter(
  withFormik({
    mapPropsToValues: props => ({
      password: '',
      password_confirmation: '',
      reset_password_token: props.match.params.reset_password_token,
    }),
    isInitialValid: false,
    validationSchema: EditPasswordSchema,
    handleSubmit: async (values, { props, setSubmitting, setErrors }) => {
      await props.handleSubmit(values, setSubmitting, setErrors);
    },
  })(EditPasswordForm),
);



// WEBPACK FOOTER //
// ./src/scenes/EditPassword/EditPasswordForm.js